<template>
  <section class="switcher" :class="{ switcher_active: isOpen }">
    <div
      class="switcher__ctrl ctrl d-flex align-center"
      @click="showHiddenMenu"
    >
      <img
        class="switcher__flag"
        :src="require(`@/assets/img/icons/flags/${currentLocale}.svg`)"
      />
      <span class="ctrl__txt px-2">{{
        formattedLocales[currentLocale] || currentLocale
      }}</span>

      <ChevronDown class="ctrl__icon" />
    </div>

    <ul class="switcher__list _px-5">
      <li
        v-for="locale in supportedLocales"
        :key="locale"
        class="switcher__item _my-3"
        @click="switchLocale(locale)"
      >
        <img
          class="switcher__flag"
          :src="require(`@/assets/img/icons/flags/${locale}.svg`)"
        />
        {{ formattedLocales[locale] || locale }}
      </li>
    </ul>
  </section>
</template>

<script>
import { Trans } from '@/plugins/translation'
import ChevronDown from 'icons/ChevronDown'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'LocaleSwitcher',
  components: {
    ChevronDown,
  },
  data: () => ({
    locales: process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(','),
    isOpen: false,
  }),
  computed: {
    ...mapGetters(['user']),
    supportedLocales() {
      return Trans.supportedLocales
    },
    currentLocale() {
      return Trans.currentLocale
    },
    formattedLocales() {
      return {
        az: 'AZ',
        be: 'BY',
        en: 'EN',
        et: 'ET',
        hy: 'AM',
        ka: 'GE',
        kk: 'KZ',
        ky: 'KG',
        lt: 'LT',
        lv: 'LV',
        mn: 'MN',
        ru: 'RU',
        uz: 'UZ',
      }
    },
  },
  methods: {
    ...mapActions(['fetchLocale']),
    async switchLocale(locale) {
      if (this.$gtm) {
        this.$gtm.push({
          event: 'ev_language',
        })
      }
      locale = locale || process.env.VUE_APP_I18N_LOCALE
      if (this.$i18n.locale !== locale) {
        let to = this.$route

        return Trans.changeLocale(locale).then(async () => {
          if (this.user && Object.keys(this.user).length) {
            await this.fetchLocale(locale).then(() => {
              to = this.helpers.buildRoute({
                name: to.name,
                params: { ...to.params, locale: locale },
                query: to.query,
              })
              this.$router.push(to)
            })
          } else {
            to = this.helpers.buildRoute({
              name: to.name,
              params: { ...to.params, locale: locale },
              query: to.query,
            })
            this.$router.push(to)
          }
        })
      }
    },
    showHiddenMenu() {
      this.isOpen = !this.isOpen
    },
  },
}
</script>

<style lang="scss" scoped>
.switcher {
  position: relative;
  &__flag {
    width: 12px;
    height: 12px;
    object-fit: contain;
    margin-right: 4px;
    border: 1px solid #cfcfcf;
  }
  &_active {
    .ctrl__icon {
      transform: scaleY(-1);
    }

    .switcher__list {
      top: calc(100%);
      visibility: visible;
      opacity: 1;

      @media screen and (max-width: 1220px) {
        top: auto;
        bottom: 100%;
      }
    }
  }
  &__list {
    position: absolute;
    top: -300px;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    background-color: color(white);
    border: 1px solid color(light-grey);
    box-shadow: 7px 7px 4px rgba(0, 0, 0, 0.01), 4px 4px 3px rgba(0, 0, 0, 0.05),
      2px 2px 3px rgba(0, 0, 0, 0.09), 0px 0px 1px rgba(0, 0, 0, 0.1),
      0px 0px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    transition: all 0.3s ease;
    z-index: 1;
    visibility: hidden;

    @media screen and (max-width: 1220px) {
      top: auto;
      bottom: 100%;
    }
  }
  &__item {
    text-transform: uppercase;
    transition: 0.3s;
    color: color(dark);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    &:hover {
      color: color(green-main);
    }
  }
}

.ctrl {
  color: color(green-main);
  text-transform: uppercase;
  cursor: pointer;

  @media screen and (max-width: 1220px) {
    color: color(dark);
  }

  &__txt {
    transition: all 0.3s ease;
  }
  &__icon {
    transition: all 0.3s ease;
  }
}
</style>
